import React from 'react'
import CheckboxColView from '../../../components/forms/checkboxColForm/CheckboxColView'
import { Row, Col } from 'rsuite'

export default function ChkAreaSettingView(props) {
  const { schema } = props
  // console.log('props', props)
  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div>
            <p style={{ marginBottom: 10 }}>
              <b>{schema.areaCriteria.label || null} :</b>{' '}
              {schema.areaCriteria.value ? schema.areaCriteria.value : '- ไม่ได้ระบุ -'}
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <b>{schema.header} :</b>
          <Row style={{ marginLeft: 10 }}>
            <CheckboxColView schema={schema.areaSetting} column={1} />
          </Row>
        </Col>
      </Row>
    </>
  )
}
